<template>
  <div style="background-color: #fafafa;padding: 20px">

    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/package' }">问题分析</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-row style="margin-top: 15px">
      <el-col :span="22" style="display: flex;align-items: center">
        <div style="font-size: 25px"><p>问题分析</p></div>
        <div style="margin-left: 20px">
          <el-button-group>
            <el-button size="small" :disabled="tab === 1" :type="tab === 1 ? 'primary':''" plain @click="tab = 1">问题查询</el-button>
            <el-button size="small" :disabled="tab === 2" :type="tab === 2 ? 'primary':''" plain @click="tab = 2">固定问答</el-button>
          </el-button-group>
        </div>
        <div style="margin-left: 20px" v-if="tab === 2">
          <el-button size="small" type="primary" :loading="ruleForm.loading" @click="addProblemOpen(1)">新增问答</el-button>
        </div>
      </el-col>
      <el-col :span="2">
        <div style="color: #EF6C00;font-size: 25px"><i class="el-icon-loading" v-if="loading2"></i></div>
      </el-col>
    </el-row>

    <div style="width: 100%; font-size: 25px" v-if="tab === 1">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" style="margin-top: 10px;width: 800px">
        <el-form-item label="关键词：" prop="search" v-if="ruleForm.problem !== 4" >
          <el-input :placeholder="ruleForm.problem === 1 ? 'PID/导购ID/导购手机号/导购名':'导购手机号/导购ID'" style="width: 400px" v-model="ruleForm.search" clearable></el-input>
        </el-form-item>
        <el-form-item label="申报时间：" v-if="ruleForm.problem === 1" prop="timeRange" style="margin-left: 80px;">
          <div style="display: flex; align-items: center;">
            <el-select v-model="ruleForm.timeRange" placeholder="请选择问题" style="width: 320px">
              <el-option key="0" label="最近两周" value="0"/>
              <el-option key="1" label="最近一个月" value="1"/>
              <el-option key="2" label="最近三个月" value="2"/>
              <el-option key="3" label="最近半年" value="3"/>
              <el-option key="4" label="最近一年" value="4"/>
              <el-option key="all" label="所有时间" value="all"/>
            </el-select>
            <div style="color: red;margin-left: 10px">仅对非流程编号的关键词查询生效</div>
          </div>
        </el-form-item>
        <el-form-item label="小票交易时间：" v-if="ruleForm.problem === 1" prop="ticketTime">
          <el-date-picker popper-class="datePicker" v-model="ruleForm.ticketTime" type="datetime" style="width: 400px" clearable format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :editable="false" placeholder="选择小票交易时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="问题：" prop="problem" class="problem">
          <el-select v-model="ruleForm.problem" filterable placeholder="请选择问题" @change="problemChange" style="width: 400px">
            <el-option
              v-for="item in ruleForm.problemList"
              :key="item.value"
              :label="item.text"
              :value='item.value'>
            </el-option>
          </el-select>
          <div style="font-size: 12px;color: #8c939d">{{ruleForm.problemList.find(it => it.value === ruleForm.problem).description || ''}}</div>
        </el-form-item>
        <el-form-item label="只查异常单：" prop="abnormal" v-if="ruleForm.problem === 1">
          <el-checkbox v-model="ruleForm.abnormal"/>
        </el-form-item>
        <el-form-item>
          <el-button :loading="ruleForm.loading" @click="searchProblem">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div v-if="results.length > 0 && tab === 1">
      <div v-if="ruleForm.problem === 4" style="display: flex;justify-content: space-between">
        <el-button-group>
          <el-button size="small" :disabled="resultIndex === 0" :type="resultIndex === 0 ? 'primary':''" plain @click="resultIndex = 0">常规滞留单({{results[0].length}})</el-button>
          <el-button size="small" :disabled="resultIndex === 1" :type="resultIndex === 1 ? 'primary':''" plain @click="resultIndex = 1">无提成规则({{results[1].length}})</el-button>
        </el-button-group>
        <div>
          <el-button size="small" type="primary" plain v-if="resultIndex === 1 && results[resultIndex].length > 0 && !suspend.batch" @click="() => {suspend.batch = true;suspend.pids = []}">批量挂起</el-button>
          <el-button size="small" type="primary" plain v-if="resultIndex === 1 && results[resultIndex].length > 0 && !suspend.batch" @click="chooseSuspend('all')">全部挂起</el-button>
        </div>
        <el-button-group v-if="resultIndex === 1 && results[resultIndex].length > 0 && suspend.batch">
          <el-button size="small" type="primary" plain :disabled="suspend.pids.length === 0" @click="chooseSuspend()">批量挂起{{suspend.pids.length > 0 ? '(' + suspend.pids.length + ')' : ''}}</el-button>
          <el-button size="small" plain @click="cancelSuspend()">取消</el-button>
        </el-button-group>
      </div>
      <el-table
        v-if="ruleForm.problem === 1 || ruleForm.problem === 4"
        :data="ruleForm.problem === 4 ? results[resultIndex] : results"
        max-height="600"
        v-loading="ruleForm.loading"
        style="width: 100%;padding-left: 30px">
        <el-table-column
          label="小票"
          align="center"
          width="150">
          <template slot-scope="scope">
            <el-image
              :ref="'preview_' + scope.row.pid"
              style="width: 100px; height: 100px"
              @error="() => errorImg(scope.row)"
              :src="scope.row.img + '/resize,m_pad,w_100,h_100'"
              :preview-src-list="[scope.row.img]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="pid"
          prop="pid"
          align="center"
          width="130">
        </el-table-column>
        <el-table-column
          label="导购"
          prop="saleName"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="供应商"
          prop="supplierName"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="品牌"
          prop="brandName"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="申报时间"
          prop="createdAt"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          label="流转时间"
          prop="aaCreatedAt"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          label="流程状态"
          prop="statusName"
          align="center"
          width="80">
        </el-table-column>
        <el-table-column
          label="原因类型"
          prop="typeValue"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          label="原因"
          prop="message"
          show-overflow-toolti
          align="center">
          <template slot-scope="s">
            <el-tooltip v-if="s.row.type !== '4'" effect="dark" placement="top">
              <template slot="content">
                <div style="white-space: pre-line">{{s.row.message}}</div>
              </template>
              <div class="multi-line-ellipsis" style="white-space: pre-line">{{s.row.message}}</div>
            </el-tooltip>
            <el-tooltip v-if="s.row.type === '4' && s.row.sub" effect="dark" placement="top">
              <template slot="content">
                <div style="white-space: pre-line">{{s.row[s.row.sub].message}}</div>
              </template>
              <div class="multi-line-ellipsis" style="white-space: pre-line">{{s.row[s.row.sub].message}}</div>
            </el-tooltip>
            <div v-if="s.row.type === '4' && !s.row.sub">
              <div>交易时间：{{s.row.ticketTime}}</div>
              <div>
                <el-button size="small" @click="openNewTicket(s.row,1)">正确</el-button>
                <el-button size="small" @click="openNewTicket(s.row,2)">错误</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.type == '7'" style="margin-bottom: 10px">
              <el-button size="small" v-if="!suspend.batch" @click="openManger(scope.row)">业务沟通</el-button>
              <el-button size="small" style="margin-top: 10px" v-if="!suspend.batch" @click="chooseSuspend(scope.row.pid)">挂起</el-button>
              <el-checkbox-group v-else v-model="scope.row.suspend" @change="(val) => checkedClick(val,scope.row.pid,scope.$index)">
                <el-checkbox label="挂起"/>
              </el-checkbox-group>
            </div>
            <div><el-button size="small" v-if="scope.row.type && !(scope.row.type === '4' && !scope.row.sub)" @click="scope.row.copyMessage && scope.row.statusName !== '结算成功' ? handleCopy2('.copy-',scope.$index) : (scope.row.type === '4' ? handleCopy(scope.row[scope.row.sub].message):handleCopy(scope.row.message))">复制</el-button></div>
            <div v-if="scope.row.type == '14'" style="margin-top: 10px"><el-button size="small" @click="openInvite(scope.row)">邀请</el-button></div>
            <div v-if="scope.row.type == '12' && ((scope.row.position === '审单员' && !scope.row.blankApplyId) || scope.row.autoBack)" style="margin-top: 10px"><el-button size="small" @click="openRetrial(scope.row,scope.$index)">取回</el-button></div>
            <div v-if="scope.row.type == '12' && scope.row.position === '审单员' && !scope.row.blankApplyId" style="margin-top: 10px"><el-button size="small" @click="openManger(scope.row)">业务沟通</el-button></div>
            <div v-if="scope.row.statusName === '结算成功' && scope.row.copyMessage" style="margin-top: 10px"><el-button size="small" @click="handleCopy2('.copy-',scope.$index)">导购反应漏报</el-button></div>
            <div v-if="scope.row.statusName === '结算成功'" style="margin-top: 10px"><el-button size="small" @click="openOperation(scope.row,scope.$index)">补撤处理</el-button></div>
          </template>
        </el-table-column>
      </el-table>

      <el-table
        v-if="ruleForm.problem === 2"
        :data="results"
        max-height="600"
        :span-method="objectSpanMethod"
        v-loading="ruleForm.loading"
        style="width: 100%;padding-left: 30px">
        <el-table-column
          label="供应商"
          prop="supplierName"
          align="center"
          width="200">
        </el-table-column>
        <el-table-column
          label="业务员"
          align="center"
          width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.managerId">{{scope.row.managerName}}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="签约状态"
          prop="signStatusDesc"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="原因类型"
          prop="typeValue"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          label="原因"
          prop="message"
          show-overflow-toolti
          align="center">
          <template slot-scope="scope">
            <el-tooltip effect="dark" placement="top">
              <template slot="content">
                <div style="white-space: pre-line">{{scope.row.message}}</div>
              </template>
              <div style="display: flex;align-items: center">
                <div class="multi-line-ellipsis" style="white-space: pre-line;flex: 1">{{scope.row.message}}</div>
                <div style="margin-left: auto;cursor: pointer;width: 35px;height: 35px;border-radius: 50%;border: 2px solid #9f9f9f" @click="showDetails(scope.row)">
                  <i class="el-icon-zoom-in" style="color: #5cb6ff;line-height: 32px" @click="showDetails(scope.row)"/>
                </div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="150">
          <template slot-scope="scope">
            <div><el-button size="small" @click="handleCopy2('.copy-',0)">复制</el-button></div>
            <div style="margin-top: 10px"><el-button size="small" @click="openInvite(scope.row)">邀请</el-button></div>
          </template>
        </el-table-column>
      </el-table>

      <el-table
        v-if="ruleForm.problem === 3"
        :data="results"
        max-height="600"
        :span-method="objectSpanMethod"
        v-loading="ruleForm.loading"
        style="width: 100%;padding-left: 30px">
        <el-table-column
          label="导购员"
          prop="saleName"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          label="连锁"
          prop="storeBrand"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          label="门店"
          prop="storeName"
          align="center"
          width="200">
        </el-table-column>
        <el-table-column
          label="原因类型"
          prop="typeValue"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          label="原因"
          prop="message"
          show-overflow-toolti
          align="center">
          <template slot-scope="scope">
            <el-tooltip effect="dark" placement="top">
              <template slot="content">
                <div style="white-space: pre-line">{{scope.row.message}}</div>
              </template>
              <div class="multi-line-ellipsis" style="white-space: pre-line">{{scope.row.message}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="150">
          <template slot-scope="scope">
            <div><el-button size="small" @click="handleCopy2('.copy-',0)">复制</el-button></div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="tab === 2" style="margin-top: 20px">
      <el-table
        :data="problemList2"
        max-height="600"
        style="width: 100%;padding-left: 30px">
        <el-table-column
          label="问题"
          prop="text"
          align="center"
          width="250">
          <template slot-scope="scope">
            <div>
              <div>{{scope.row.text}}<i class="el-icon-delete" style="cursor: pointer;color: red;margin-left: 10px" @click="updateProblem(scope.row.text,true)"></i></div>
              <div v-if="scope.row.description" style="display: flex;justify-content: center;">
                <div>（</div>
                <el-tooltip effect="dark" placement="top" :content="scope.row.description">
                  <div class="multi-line-ellipsis" style="font-size: 12px;color: #8c939d;-webkit-line-clamp: 1">{{scope.row.description}}</div>
                </el-tooltip>
                <div>）</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="回答"
          prop="value"
          align="center">
          <template slot-scope="scope">
            <el-tooltip effect="dark" placement="top">
              <template slot="content">
                <div style="white-space: pre-line">{{scope.row.value}}</div>
              </template>
              <div class="multi-line-ellipsis" style="white-space: pre-line;-webkit-line-clamp: 2">{{scope.row.value}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="150">
          <template slot-scope="scope">
            <div><el-button size="small" @click="handleCopy2('.copy2-',scope.$index)">复制</el-button></div>
            <div><el-button size="small" @click="addProblemOpen(2,scope.row)" style="margin-top: 10px">编辑</el-button></div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div :class="'copy-' + index" style="width: 100%;white-space: pre-line" v-if="results.length > 0" v-for="(item,index) in results">
      <div style="font-size: 1px;color: transparent;">{{item.copyMessage ? item.copyMessage : item.message}}</div>
      <div v-if="item.copyImgUrls">
        <img :src="url" v-for="url in item.copyImgUrls" style="width: 1px;height: 1px"/>
      </div>
    </div>

    <div :class="'copy2-' + index" style="width: 100%;white-space: pre-line" v-for="(item,index) in problemList2">
      <div v-if="item.value || item.copyMessage || item.copyImgUrls">
        <div style="font-size: 1px;color: transparent;" v-if="item.copyMessage">{{item.copyMessage}}</div>
        <div style="font-size: 1px;color: transparent;" v-else-if="item.value">{{item.value}}</div>
        <div v-if="item.copyImgUrls">
          <img :src="url" v-for="url in item.copyImgUrls" style="width: 1px;height: 1px"/>
        </div>
      </div>
    </div>

    <div :class="'copy3-' + index" style="width: 100%;white-space: pre-line" v-if="resultDetails.list.length > 0" v-for="(item,index) in resultDetails.list">
      <div style="font-size: 1px;color: transparent;">{{item.copyMessage ? item.copyMessage : item.message}}</div>
      <div v-if="item.copyImgUrls">
        <img :src="url" v-for="url in item.copyImgUrls" style="width: 1px;height: 1px"/>
      </div>
    </div>

    <el-dialog title="填写正确时间" :visible.sync="ticket.show" width="300px" v-loading="loading">
      <el-date-picker popper-class="datePicker" style="width: 100%" v-model="ticket.newTime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :editable="false" type="datetime"></el-date-picker>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ticket.show = false" size="small">取 消</el-button>
        <el-button @click="ticket.previewList = [ticket.img]" size="small">查看小票</el-button>
        <el-button type="primary" @click="setTicketTime(2)" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="获取邀请签约链接" :visible.sync="invite.show" width="400px" v-loading="loading" center>
      <div>
        <span>品牌：</span><el-input style="width: 300px" placeholder="请输入内容" v-model="invite.data.parentBrand" clearable></el-input>
      </div>
      <div style="margin-top: 10px" v-if="invite.data.msg">{{invite.data.link ? invite.data.info : invite.data.msg}}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="invite.show = false" size="small">取 消</el-button>
        <el-button v-if="!invite.data.msg" type="primary" @click="handleInvite" size="small">确 定</el-button>
        <el-button v-if="invite.data.link" type="primary" @click="handleCopy(invite.data.msg)" size="small">复制链接</el-button>
        <el-button v-else-if="invite.data.msg" type="primary" @click="handleCopy(invite.data.msg)" size="small">复制</el-button>
      </div>
    </el-dialog>

    <el-dialog title="滞留单挂起" :visible.sync="suspend.show" width="400px" v-loading="loading" center>
      <div>
        <span>挂起原因：</span><el-input style="width: 300px" placeholder="请输入内容" v-model="suspend.remark" clearable></el-input>
      </div>
      <div>
        <span>挂起天数：</span>
        <el-select style="width: 300px" v-model="suspend.day" placeholder="请选择挂起天数">
          <el-option label="1天" :value="1"></el-option>
          <el-option label="3天" :value="3"></el-option>
          <el-option label="7天" :value="7"></el-option>
          <el-option label="30天" :value="30"></el-option>
          <el-option label="永久" :value="1000"></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="suspend.show = false">取 消</el-button>
        <el-button type="primary" @click="processSuspend">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="流程取回" :visible.sync="retrialDialog.show" width="450px" center>
      <div>
        {{retrialDialog.autoBack ? '您确定要取回重审吗？这将恢复为业务员审核状态。' : '您确定要取回重审吗？这将恢复为审单员审核状态。'}}
      </div>
      <div style="margin-top: 20px" v-if="!retrialDialog.autoBack">
        <el-radio v-model="retrialDialog.type" :label="1">审单错</el-radio>
        <el-radio v-model="retrialDialog.type" :label="2">业务要求</el-radio>
        <el-radio v-model="retrialDialog.type" :label="3">数据错</el-radio>
        <el-radio v-model="retrialDialog.type" :label="4">其他</el-radio>
      </div>
      <div style="margin-top: 20px" v-if="retrialDialog.autoBack || retrialDialog.type === 4">
        <el-input placeholder="请输入取回原因" v-model="retrialDialog.reason" clearable></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="retrialDialog = {}">取 消</el-button>
        <el-button @click="handleCopy(retrialDialog.message)">复 制</el-button>
        <el-button :disabled="(!retrialDialog.type && !retrialDialog.autoBack) || (retrialDialog.type === 4 && !retrialDialog.reason)" type="primary" @click="retrial">确 定</el-button>
      </div>
    </el-dialog>

    <image-viewer v-if="showViewer" :url-list="previewList" :on-close="() => showViewer = false" :z-index="9999"/>
    <el-dialog title="业务沟通" :visible.sync="managerDialog.show" width="450px" center>
      <div>
        <div>
          <span>导购：{{managerDialog.data.saleName}}</span>
          <span style="margin-left: 20px">手机号：{{managerDialog.data.mobile}}</span>
        </div>
        <div>{{managerDialog.data.address}}&nbsp;&nbsp;&nbsp;&nbsp;{{managerDialog.data.storeInfo}}</div>
      </div>
      <div style="margin-top: 20px;display: flex">
        <div>导购反馈：</div>
        <el-input type="textarea" ref="messageInput" v-model="managerDialog.message" @input="handleMessageInput" :rows="3" placeholder="请问这张小票是否可以审核通过发放提成?" style="width: 300px" clearable/>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showTicket">查看小票</el-button>
        <el-button @click="handleCopy(managerDialog.data.saleInfo)">仅复制导购信息</el-button>
        <el-button type="primary" @click="managerDialogCopy">一键复制全部信息</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="addProblem.type === 2 ? '编辑问答' : '新增问答'" :visible.sync="addProblem.show" width="500px" v-loading="loading" center :close-on-press-escape="false" :close-on-click-modal="false">
      <div>
        <span>问题：</span><el-input style="width: 400px" placeholder="请输入问题" v-model="addProblem.data.question" clearable></el-input>
      </div>
      <div style="margin-top: 10px">
        <span>描述：</span><el-input style="width: 400px" placeholder="请输入描述" v-model="addProblem.data.description" clearable></el-input>
      </div>
      <div style="margin-top: 10px;display: flex;align-items: flex-start">
        <span>回答：</span><el-input type="textarea" :rows="5" style="width: 400px" placeholder="请输入回答" v-model="addProblem.data.answer" clearable></el-input>
      </div>
      <div class="form-row image-row">
        <span>图片：</span>
        <el-upload
          v-if="!addProblem.data.imageUrl"
          class="image-uploader"
          action="#"
          accept="image/*"
          :show-file-list="false"
          :http-request="uploadImage"
          :before-upload="beforeImageUpload"
        >
          <i class="el-icon-plus image-uploader-icon"></i>
        </el-upload>
        <div v-else class="uploaded-image">
          <img :src="addProblem.data.imageUrl" alt="已上传图片" />
          <i class="el-icon-close delete-image"
            title="删除图片"
            @click="() => addProblem.data.imageUrl = null">
          </i>
        </div>
        <el-button v-if="addProblem.data.imageUrl" style="margin-left: 20px" type="primary" plain size="mini" @click="handleCopy('imgUrl=' + addProblem.data.imageUrl)">复制</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addProblem.show = false">取 消</el-button>
        <el-button type="primary" v-if="addProblem.type === 2" @click="updateProblem">确 定</el-button>
        <el-button type="primary" v-else @click="addProblemConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <image-viewer v-if="ticket.show && ticket.previewList.length > 0" :z-index="9999" :initial-index="0" :on-close="() => ticket.previewList = []" :url-list="ticket.previewList"/>

    <el-dialog title="问题详情" :visible.sync="resultDetails.show" width="800px" :close-on-press-escape="false" :close-on-click-modal="false">
      <el-table :data="resultDetails.list">
        <el-table-column
          label="供应商"
          prop="supplierName"
          align="center"
          width="200">
        </el-table-column>
        <el-table-column
          label="原因"
          prop="message"
          show-overflow-toolti
          align="center">
          <template slot-scope="scope">
            <el-tooltip effect="dark" placement="top">
              <template slot="content">
                <div style="white-space: pre-line">{{scope.row.message}}</div>
              </template>
              <div class="multi-line-ellipsis" @click="showDetails(scope.row)" style="white-space: pre-line">{{scope.row.message}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="150">
          <template slot-scope="scope">
            <div><el-button size="small" @click="handleCopy2('.copy3-',0)">复制</el-button></div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="补撤处理" :visible.sync="operation.open" width="1000px" class="productDialog" :close-on-press-escape="false" :close-on-click-modal="false">
      <div style="display: flex">
        <div>
          <div>流程编号：{{operation.process.pid}}</div>
          <div style="margin-top: 5px">申报人：{{operation.process.address + ' ' + operation.process.storeInfo + ' ' + operation.process.saleName}}</div>
        </div>
        <div style="margin-left: 40px">
          <el-button @click="openImg" size="mini">查看小票</el-button>
        </div>
      </div>
      <div style="margin-top: 20px;display: flex;align-items: center;">
        <div>
          <div>
            <span>补撤类型：</span>
            <el-radio v-model="operation.type" @change="operation.reason = '产品/时间/价格审核有误'" :label="1">审单错</el-radio>
            <el-radio v-model="operation.type" @change="operation.reason = '供应商负责人/业务确认可通过'" :label="2">业务要求</el-radio>
            <el-radio v-model="operation.type" @change="operation.reason = '系统建品有误'" :label="3">数据错</el-radio>
            <el-radio v-model="operation.type" @change="operation.reason = operation.description" :label="4">其他</el-radio>
          </div>
          <div style="margin-top: 10px">
            <span>补撤理由：</span>
            <el-input v-model="operation.description" maxlength="50" clearable size="small" style="width: 300px"/>
          </div>
        </div>
        <div style="margin-left: auto">
          <el-button size="small" type="primary" plain @click="calculate">{{operation.isCalculate ? '继续修改' : '开始计算'}}</el-button>
        </div>
      </div>
      <el-table :data="operation.salesVolumes" style="margin-top: 10px" v-loading="operationLoading">
        <el-table-column property="productInfo" label="产品" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.productId">
              <span :style="{color: scope.row.newPid ? 'rgb(60, 136, 247)' : ''}">{{scope.row.productInfo}}</span>
              <i class="el-icon-delete" v-if="!scope.row.pid && scope.row.newPid" style="cursor: pointer;color: red;margin-left: 10px" @click="countEdit(scope.row,0,scope.$index)"/>
            </div>
            <el-button style="color: #3a8ee6" @click="() => operation.isSearch = true" :disabled="operation.isCalculate" v-else-if="operation.supplierProducts && operation.supplierProducts.length > 0 && !operation.isSearch" type="text">{{scope.row.productInfo}}</el-button>
            <div v-else-if="operation.isSearch">
              <el-select v-model="operation.productSelect" @change="(val) => productSelectChange(val)" style="width: 350px" placeholder="请输入商品条形码(至少4位)/商品名称" clearable filterable>
                <el-option
                  v-for="item in operation.supplierProducts"
                  :key="item.productId"
                  :label="item.info"
                  :disabled="operation.supplierProductMap[item.productId].flag"
                  :value="item.productId">
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="productCount" label="原报数量" align="center" width="120">
          <template slot-scope="scope">
            <span>{{scope.row.pid && scope.row.newPid ? 0 : scope.row.productCount}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="补撤数量" width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.productId">
              <el-input-number v-model="scope.row.editCount" @change="(val) => countEdit(scope.row,val,scope.$index)" v-if="scope.row.isOperation" :disabled="scope.row.disabledEdit || operation.isCalculate" controls-position="right" :min="scope.row.minCount" :max="scope.row.maxCount" size="small" style="width: 120px"></el-input-number>
              <span v-else>{{scope.row.newPid ? scope.row.productCount : scope.row.status}}</span>
            </div>
            <div v-else style="color: red">
              {{scope.row.countTotal}}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="补撤金额" width="160">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;justify-content: center">
              <div v-if="!scope.row.pid && scope.row.productId">
                {{scope.row.editAmount}}
              </div>
              <div v-else-if="scope.row.productId">
                <el-input-number v-model="scope.row.editAmount" v-if="scope.row.isOperation" :disabled="scope.row.disabledEdit || operation.isCalculate" controls-position="right" :min="scope.row.minAmount" :precision="2" :step="1" :max="scope.row.maxAmount" size="small" style="width: 120px"></el-input-number>
                <span v-else>{{scope.row.bonus}}</span>
              </div>
              <div v-else style="color: red">
                {{scope.row.amountTotal}}
              </div>
              <el-tooltip effect="dark" placement="top" v-if="scope.row.remark">
                <template slot="content">
                  <div>{{scope.row.remark}}</div>
                </template>
                <i class="el-icon-info" style="font-size: 16px;margin-left: 5px"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 30px;display: flex;justify-content: center">
        <el-button plain @click="() => operation = {open: false,process:{}}" :loading="operationLoading">取消</el-button>
        <el-button type="primary" :disabled="!operation.isCalculate || !operation.isSubmit || !operation.description" :loading="operationLoading" @click="operationSubmit" style="margin-left: 50px">确认提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addProblemConfirm, editProblem, getSettlementSubmitMsg,
  invitationLink,
  problemSearch, processInfo,
  processSuspend, retrial,
  setNewTicketTime, settlementSubmit, uploadImg
} from "@/api/ProblemAnalysis";
import ImageViewer from "element-ui/packages/image/src/image-viewer.vue"
import {init} from "@/api/ProblemAnalysis";
import {getValidImageUrl} from "@/utils/validate";

export default {
  name: 'ProblemAnalysis',
  components:{ImageViewer},
  data() {
    return {
      ruleForm: {
        ticketTime: '',
        search: '',
        problemList:[{text:'为什么没发钱',description: '小票过期/“小票已过期”/“小票申报期限为”为什么小票会被退回？漏报产品/少发钱/结算产品数量不对？',value:1},
          {text:'如何销量申报/为什么不能报小票',value:2},{text:'不能提现/不愿意验证',
          description: '不能提现/不愿意验证/怎么提现/“请谨慎选择您的纳税人类型”/“需人脸验证签约”/“您领取的资金将作为劳务报酬收入进行税务申报”/“请确认以下为您身份证上的真实姓名”？',value:3},
          {text:'查看滞留单',value:4}],
        problem: 1,
        loading: false,
        timeRange: '0',
        abnormal: true
      },
      problemList2: [],
      token: '',
      resultIndex: 0,
      rules: {
        problem: [
          {required: true, message: '请选择问题。', trigger: 'change'}
        ]
      },
      loading: false,
      results:[],
      ticket: {pid: '',show: false,newTime: '',img:'',previewList:[]},
      loading2: false,
      invite: {show: false,data:{}},
      suspend: {show: false, day: 1, remark : '', pids: [], batch: false},
      addProblem: {show: false, data: {}},
      tab: 1,
      resultDetails: {list:[],show:false},
      retrialDialog: {},
      managerDialog: {data:{},show: false},
      showViewer: false,
      previewList: [],
      operation: {open: false,process:{}},
      operationLoading: false
    }
  },
  mounted() {
    const supplierId = localStorage.getItem('supplierId');
    if (supplierId === '15900973961' || supplierId === '17898848378') {
      this.token = localStorage.getItem('token')
      init(this.token).then(({data}) => {
        this.problemList2 = data.data
      })
      if (this.ruleForm.problemList.length === 1) {
        this.ruleForm.problem = this.ruleForm.problemList[0].value
      }
      let params = {
        problem: 4,
        timeRange: '2'
      }
      this.loading2 = true
      problemSearch(this.token,params).then(res => {
        if (res.data && res.data.length > 0) {
          let message = `存在${res.data.length}单滞留单（已进入平台审核两天，或未进入AA表），请留意处理`
          this.$alert(message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showCancelButton: true,
            callback: action => {
              if (action === 'confirm') {
                this.ruleForm.problem = 4;
                this.resultIndex = 0
                this.tab = 1
                res.data.forEach(it => {
                  it.suspend = []
                  it.img += '?x-oss-process=image'
                  it.originalImg = it.img
                })
                const withRule =res.data.filter(it => it.statusName !== '无提成规则')
                const withoutRule = res.data.filter(it => it.statusName === '无提成规则')
                this.results = [withRule, withoutRule]
              }
            }
          });
        } else {
          this.results = []
        }
      }).finally(() => this.loading2 = false)
    } else {
      this.$router.replace({ path: '/Console' })
    }
  },
  methods: {
    searchProblem() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.search && !this.ruleForm.ticketTime && this.ruleForm.problem !== 4) {
            let message = this.ruleForm.problem === 1 ? '请输入关键词或者小票交易时间' : '请输入关键词'
            this.$notify.error({
              title: '失败',
              message: message,
              position: 'bottom-right'
            })
            return false
          }
          this.ruleForm.loading = true
          const search = this.ruleForm.search ? this.ruleForm.search.trim() : ''
          let params = {
            pid: search.length > 11 ? search : '',
            phoneNumber: /^\d+$/.test(search) && search.length === 11 ? search : '',
            saleId: /^\d+$/.test(search) && search.length === 6 ? search : '',
            saleName: (!/^\d+$/.test(search) && search.length < 11) ? search : '',
            ticketTime: this.ruleForm.ticketTime,
            problem: this.ruleForm.problem,
            timeRange: this.ruleForm.problem === 4 ? '2' : this.ruleForm.timeRange,
            abnormal: this.ruleForm.abnormal
          }
          problemSearch(this.token,params).then(res => {
            if (res.data && res.data.length > 0) {
              if (this.ruleForm.problem === 4 || this.ruleForm.problem === 1) {
                res.data.forEach(it => {
                  it.img += '?x-oss-process=image'
                  it.originalImg = it.img
                })
              }
              if (this.ruleForm.problem === 4) {
                this.resultIndex = 0
                res.data.forEach(it => it.suspend = [])
                const withRule =res.data.filter(it => it.statusName !== '无提成规则')
                const withoutRule = res.data.filter(it => it.statusName === '无提成规则')
                this.results = [withRule, withoutRule]
              } else {
                this.results = res.data
              }
            } else {
              this.results = []
              this.$notify.error({
                title: '无结果',
                message: '未查到数据'
              })
            }
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '查询失败请联系管理员！'
            })
          }).finally(() => {
            this.ruleForm.loading = false
          })
        }
      })
    },
    addProblemOpen(type,row) {
      let data = {}
      if (type === 2) {
        data = {
          question: row.text,
          description: row.description,
          answer: row.originalValue,
          oldQuestion: row.text
        }
      }
      this.addProblem = {show: true,type: type, data: data}
    },
    addProblemConfirm() {
      if (!this.addProblem.data.question || !this.addProblem.data.answer) {
        this.$notify.warning({
          title: '提示',
          message: '问题或答案不能为空'
        })
        return
      }
      addProblemConfirm(this.token,this.addProblem.data).then(({data}) => {
        console.log(data)
        if (data.data) {
          this.$notify.error({
            title: '失败',
            message: data.data
          })
        } else {
          this.problemList2.push({text: this.addProblem.data.question,description: this.addProblem.data.description, value: this.addProblem.data.answer})
          this.$notify.success({
            title: '成功',
            message: '添加成功'
          })
        }
      })
    },
    chooseSuspend (pid) {
      if (pid === 'all') {
        this.suspend.pids = this.results[this.resultIndex].map(it => it.pid)
      } else if (pid) {
        this.suspend.pids = [pid]
      }
      this.suspend.remark = ''
      this.suspend.show = true
      this.suspend.day = 1
    },
    checkedClick(val,pid,index) {
      if (val.length === 0) {
        this.results[this.resultIndex][index].suspend = []
        this.suspend.pids = this.suspend.pids.filter(it => it !== pid)
      } else {
        this.suspend.pids.push(pid)
      }
    },
    cancelSuspend() {
      this.suspend.batch = false;
      this.suspend.pids = []
      this.results[this.resultIndex].forEach(it => it.suspend = [])
    },
    processSuspend() {
      if (!this.suspend.pids || this.suspend.pids.length === 0) {
        this.$notify.warning({
          title: '提示',
          message: '请选择挂起流程',
          position: 'bottom-right'
        })
        return
      }
      if (!this.suspend.remark) {
        this.$notify.warning({
          title: '提示',
          message: '挂起原因不能为空',
          position: 'bottom-right'
        })
        return
      }
      this.loading = true
      processSuspend(this.token,this.suspend).then(() => {
        this.results[this.resultIndex] = this.results[this.resultIndex].filter(item => !this.suspend.pids.includes(item.pid))
        this.suspend.pids = []
        this.suspend.remark = ''
        this.suspend.show = false
        this.suspend.batch = false
        this.$notify.success({
          title: '成功',
          message: '挂起成功'
        })
      }).finally(() => this.loading = false)
    },
    openInvite(row) {
      this.invite = {
        show: true,
        data: {
          saleId: row.saleId,
          parentBrand: ''
        }
      }
    },
    handleInvite() {
      if (!this.invite.data || !this.invite.data.parentBrand) {
        this.$notify.warning({
          title: '提示',
          message: '请填写品牌',
          position: 'bottom-right'
        })
        return
      }
      this.loading = true
      invitationLink(this.token,this.invite.data).then(({data}) => {
        if (data && data.data) {
          this.invite.data.link = data.data.link
          this.invite.data.info = data.data.info
          this.invite.data.msg = data.data.msg
        } else {
          this.$notify.error({
            title: '失败',
            message: '无可推荐签约！'
          })
        }
      }).finally(() => this.loading = false)
    },
    handleCopy(text) {
      if (!text) return
      this.$copyText(text).then(
        (e) => {
          this.$message.success('复制成功!')
        },(e) =>{
          this.$message.error('复制失败!')
        }
      )
    },
    handleCopy2(className,index) {
      let selection = window.getSelection();
      let container = document.querySelector(className + index);
      if (selection.rangeCount > 0) {
        selection.removeAllRanges();
      }
      const range = document.createRange();
      range.selectNode(container);
      selection.addRange(range);
      document.execCommand("copy");
      selection.removeAllRanges();
      this.$message.success('复制成功!')
    },
    openNewTicket(row,type) {
      if (type === 2) {
        this.ticket = {
          pid: row.pid,
          show: true,
          newTime: null,
          img: row.img,
          previewList: []
        }
      } else if (type === 1) {
        this.ticket = {pid: row.pid}
        this.$confirm('是否仍将此单加入结算白名单？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        }).then(() => {
          this.setTicketTime(type)
        }).catch(() => {
          this.$set(this.results.find(item => item.pid === row.pid), 'sub', 'sub1')
        })
      }
    },
    setTicketTime(type) {
      if (type === 2 && !this.ticket.newTime) {
        this.$message.error('请填写正确时间!')
        return
      }
      const params = {
        pid: this.ticket.pid,
        type: type,
        newTime: type === 2 ? this.ticket.newTime : null
      }
      this.loading = true
      setNewTicketTime(this.token,params).then(({data}) => {
        if (data.code === 0) {
          this.$notify.error({
            title: '失败',
            message: data.msg
          })
        } else {
          if (type === 2) {
            this.$set(this.results.find(item => item.pid === this.ticket.pid), 'sub', 'sub2')
            this.$notify.success({
              title: '成功',
              message: '修改小票时间成功'
            })
          } else if (type === 1) {
            this.$set(this.results.find(item => item.pid === this.ticket.pid), 'sub', 'sub3')
            this.$notify.success({
              title: '成功',
              message: '已将该流程加入结算白名单'
            })
          }
        }
        this.ticket.show = false
      }).finally(() => this.loading = false)
    },
    problemChange() {
      this.results = []
      if (!this.ruleForm.search || !/^\d+$/.test(this.ruleForm.search) || this.ruleForm.search.length !== 11) {
        this.ruleForm.search = ''
      }
    },
    openRetrial(row,index) {
      this.retrialDialog = {show: true,pid: row.pid, index: index,autoBack: row.autoBack, message: row[row.position],reason: ''}
    },
    openManger(row) {
      this.managerDialog = {show: true,data: row,message: '',messageSuffixAppended: false}
    },
    handleMessageInput(value) {
      if (this.managerDialog.messageSuffixAppended || !value) {
        return
      }
      const suffix = '请问这张小票是否可以审核通过发放提成'

      const textarea = this.$refs.messageInput.$el.querySelector('textarea')
      // 记录用户当前光标位置
      const cursorStart = textarea.selectionStart
      const cursorEnd = textarea.selectionEnd

      if (!value.includes(suffix)) {
        this.managerDialog.message = value + '，' + suffix + '？'
      }
      this.managerDialog.messageSuffixAppended = true

      this.$nextTick(() => {
        const currentTextarea = this.$refs.messageInput.$el.querySelector('textarea')

        currentTextarea.focus()
        currentTextarea.setSelectionRange(cursorStart, cursorEnd)
      })
    },
    managerDialogCopy() {
      let message = `${this.managerDialog.data.saleInfo || ''}\n导购反馈：${this.managerDialog.message || '请问这张小票是否可以审核通过发放提成？'}`
      this.handleCopy(message)
    },
    showTicket() {
      this.showViewer = true
      this.previewList = [this.managerDialog.data.img]
    },
    //取回重审
    retrial() {
      const index = this.retrialDialog.index
      const pid = this.retrialDialog.pid
      this.ruleForm.loading = true
      if (this.retrialDialog.type !== 4) {
        switch (this.retrialDialog.type) {
          case 1: this.retrialDialog.reason = '产品/时间/价格审核有误'
            break
          case 2: this.retrialDialog.reason = '供应商负责人/业务确认可通过'
            break
          case 3: this.retrialDialog.reason = '系统建品有误'
            break
        }
      }
      const reason = this.retrialDialog.reason
      retrial(this.token,{pid:pid,reason:reason,type: this.retrialDialog.type}).then(({data}) => {
        if (data.data) {
          this.$notify({
            type: 'success',
            message: '取回重审成功',
            title: '成功',
            position: 'bottom-right'
          })
          this.$set(this.results, index, data.data)
        } else {
          this.$notify({
            type: 'error',
            message: '取回失败，请刷新后重试',
            title: '失败',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.ruleForm.loading = false
        this.retrialDialog = {}
      })
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 5) {
        if (rowIndex % this.results.length === 0) {
          return {
            rowspan: this.results.length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    showDetails(row) {
      this.ruleForm.loading = true
      let params = {
        phoneNumber: row.mobile,
        type: row.type,
        problem: this.ruleForm.problem,
        details: true
      }
      this.resultDetails = {list:[],show: false}
      problemSearch(this.token,params).then(res => {
        this.resultDetails = {list: res.data || [],show: true}
      }).catch(() => {
        this.$notify.error({
          title: '失败',
          message: '查询失败请联系管理员！'
        })
      }).finally(() => {
        this.ruleForm.loading = false
      })
    },
    operationSubmit() {
      let {type,description,reason,salesVolumes,index,basMsg1,basMsg2} = this.operation
      const {pid,saleId,supplierName} = this.operation.process
      if (!description) {
        this.$notify.warning({
          title: '提示',
          message: '请填写补撤理由!'
        })
        return
      }
      if (type === 4) {
        reason = description
      }
      if (!reason) {
        this.$notify.warning({
          title: '提示',
          message: '请填写补撤类型原因!'
        })
        return
      }
      let productList = salesVolumes.filter(it => it.isOperation && !it.disabledEdit && it.productId && (it.editAmount || it.editCount))
      if (productList.length === 0) {
        this.$notify.warning({
          title: '提示',
          message: '请至少补撤一个产品!'
        })
        return
      }
      productList = productList.map((x, index) => {
        x.index = index
        return x
      })
      let data = {
        pid: pid,
        type: type,
        description: description,
        reason: reason,
        productList: productList,
        saleId: saleId,
        basMsg1: basMsg1,
        basMsg2: basMsg2,
        supplierName: supplierName
      }
      this.operationLoading = true
      getSettlementSubmitMsg(this.token,data).then(res => {
        this.operationLoading = false
        this.$confirm(res.data, '确认提交', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (res.data) {
            this.handleCopy(res.data)
          }
          this.operationLoading = true
          settlementSubmit(this.token,data).then(({data}) => {
            if (data.code === 1) {
              this.operation = {open: false,process:{}}
              this.$set(this.results, index, data.data)
            } else {
              this.$notify.error({
                title: '失败',
                message: data.msg
              })
            }
          }).finally(() => this.operationLoading = false)
        }).catch(() => this.operationLoading = false)
      })
    },
    openImg() {
      const imageRef = this.$refs[`preview_${this.operation.process.pid}`]
      const imageComponent = Array.isArray(imageRef) ? imageRef[0] : imageRef
      if (imageComponent && imageComponent.$el) {
        this.$nextTick(function() {
          if (imageComponent.previewSrcList && imageComponent.previewSrcList.length > 0) {
            imageComponent.clickHandler()
          }
        })
      }
    },
    countEdit(row,val,index) {
      const {productId,maxCount,minCount,newPid} = row
      if (val > maxCount) {
        val = maxCount
      } else if (val < minCount) {
        val = minCount
      }
      row.editCount = val
      if (row.pid) {
        row.editAmount = (val * row.unitBonus).toFixed(2)
      } else if (newPid) {
        row.editAmount = '以实际结算为准'
        if (val === 0) {
          this.operation.salesVolumes.splice(index,1)
          this.operation.supplierProductMap[productId].flag = false
        }
      }
    },
    calculate() {
      const salesVolumes = this.operation.salesVolumes
      this.operation.isSearch = false
      if (this.operation.isCalculate) {
        this.operation.isCalculate = false
        this.operation.salesVolumes.splice(-1)
        if (this.operation.supplierProducts && this.operation.supplierProducts.length > 0) {
          this.operation.salesVolumes.push({productInfo: '+ 添加新增补报产品'})
        }
      } else {
        const filter = salesVolumes.filter(it => it.isOperation && !it.disabledEdit);
        const amountTotal = filter.filter(it => it.pid).map(it => it.editAmount).reduce((total, current) => total + current, 0) || 0
        const reissueTotal = filter.filter(it => it.editCount > 0).map(it => it.editCount).reduce((total, current) => total + current, 0) || 0
        const revokeTotal = filter.filter(it => it.editCount < 0).map(it => it.editCount).reduce((total, current) => total + current, 0) || 0
        this.operation.isSubmit = filter.some(it => it.editAmount !== 0 || it.editCount !== 0)
        this.operation.isCalculate = true
        const data = {
          productInfo: '+ 添加新增补报产品',
          productCount: '总计：',
          amountTotal: filter.some(it => it.pid) ? amountTotal + '元' : '以实际结算为准',
          countTotal: (reissueTotal >= 0 ? `补发:${reissueTotal}件` : '') +";"+ (revokeTotal !== 0 ? `撤回:${revokeTotal}件` : '')
        }
        const v = salesVolumes[salesVolumes.length - 1]
        if (!v.pid && !v.productId) {
          this.operation.salesVolumes.splice(-1)
        }
        this.operation.salesVolumes.push(data)
      }
    },
    productSelectChange(productId) {
      this.operation.productSelect = null
      const {brandName,productName,flag,simpleBonus,retailPrice,brandId} = this.operation.supplierProductMap[productId]
      const salesVolumes = this.operation.salesVolumes
      if (!flag) {
        const data = {
          newPid: true,
          productId: productId,
          productCount: 0,
          editCount: 1,
          maxCount: 99999,
          minCount: 0,
          editAmount: '以实际结算为准',
          simpleBonus: simpleBonus || 0,
          isOperation: true,
          retailPrice: retailPrice || 0,
          brandId: brandId || '',
          brandName: brandName || '',
          productInfo: `[${brandName}] [${productName}]`,
          productName: productName
        }
        const v = salesVolumes[salesVolumes.length - 1]
        if (!v.pid && !v.productId) {
          this.operation.salesVolumes.splice(-1)
        }
        this.operation.salesVolumes.push(data)
        this.operation.salesVolumes.push(v)
        this.operation.supplierProductMap[productId].flag = true
      }
    },
    openOperation(row,index) {
      this.operation = {open: false,process:{}}
      this.ruleForm.loading = true
      processInfo(this.token,row.pid).then(res => {
        if (res && res.data) {
          if (!res.data.salesVolumes || res.data.salesVolumes.length === 0) {
            this.$notify.error({
              title: '失败',
              message: '请刷新后重试！'
            })
          } else {
            if (res.data.supplierProducts && res.data.supplierProducts.length > 0) {
              const data = {
                productInfo: '+ 添加新增补报产品',
              }
              res.data.salesVolumes.push(data)
              res.data.supplierProducts.forEach(item => {
                const {barcode,parentBrand,productName,productCode,retailPrice} = item
                item.info = barcode + ' ' + productCode + ' ' + retailPrice + '元  ' + parentBrand + ' ' + productName
              })
            }
            this.operation = {
              open: true,
              isCalculate: false,
              isSubmit: false,
              description: '',
              productSelect: null,
              isSearch: false,
              type: 4,
              reason: '',
              index: index,
              basMsg1: row['30'] || '',
              basMsg2: row['31'] || '',
              process: {pid: row.pid,address: row.address,storeInfo: row.storeInfo,saleName: row.saleName,ticketImg: row.img,saleId: row.saleId,supplierName: row.supplierName},
              salesVolumes: res.data.salesVolumes || [],
              supplierProducts: res.data.supplierProducts || [],
              supplierProductMap: res.data.supplierProductMap || {}
            }
          }
        }
      }).finally(() => {
        this.ruleForm.loading = false
      })
    },
    updateProblem(id,isDelete) {
      let data = {}
      if (isDelete) {
        data = {question: id,isDelete: true}
      } else {
        data = this.addProblem.data
        if (!this.addProblem.data.question || !this.addProblem.data.answer) {
          this.$notify.warning({
            title: '提示',
            message: '问题或答案不能为空'
          })
          return
        }
      }
      this.loading = true
      editProblem(this.token,data).then(({data}) => {
        if (data && data.data) {
          this.loading = false
          this.$notify.error({
            title: '失败',
            message: data.data
          })
        } else {
          this.$notify.success({
            title: '成功',
            message: '修改成功'
          })
          init(this.token).then(({data}) => {
            this.problemList2 = data.data
            this.addProblem.show = false
            this.loading = false
          })
        }
      })
    },
    beforeImageUpload(file) {
      const isImage = file.type.indexOf('image/') === 0;
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isImage) {
        this.$message.error('只能上传图片文件');
        return false;
      }

      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB');
        return false;
      }

      return true;
    },

    async uploadImage(options) {
      const formData = new FormData()
      formData.append('file', options.file)
      formData.append(this.addProblem.data.question, options.file)
      try {
        this.loading = true
        uploadImg(this.token,formData).then(({data}) => {
          this.$set(this.addProblem.data, 'imageUrl', data.data)
          this.$notify.success({
            title: '成功',
            message: '图片上传成功'
          })
        })
      } catch (error) {
        this.$notify.error({
          title: '失败',
          message: '图片上传失败'
        })
      } finally {
        this.loading = false
      }
    },
    errorImg(item) {
      let {originalImg,errorcount} = item
      errorcount = errorcount || 0
      if (errorcount > 1) return
      item.img = null
      let imgUrl = getValidImageUrl(originalImg,errorcount)
      errorcount ++
      item.img = imgUrl
      item.errorcount = errorcount
    }
  }
}
</script>

<style>
.datePicker .el-button--text {
  display: none;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.multi-line-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制显示行数 */
  overflow: hidden;
}

.problem .el-form-item__content {
  line-height: 30px !important;
}

.productDialog .el-dialog__body {
  padding-top: 0 !important;
}

.form-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.form-row:first-child {
  margin-top: 0;
}

.form-row > span {
  width: 42px;
  flex-shrink: 0;
}

.answer-row,
.image-row {
  align-items: flex-start;
}

.image-uploader .el-upload{
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}

.image-uploader .el-upload:hover {
  border-color: #409eff;
}

.image-uploader-icon {
  width: 100px;
  height: 100px;
  font-size: 28px;
  color: #8c939d;
  line-height: 100px !important;
  text-align: center;
}

.uploaded-image {
  position: relative;
  width: 100px;
  height: 100px;
}

.uploaded-image img {
  display: block;
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
}

.delete-image {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 2;
  width: 20px;
  height: 20px;
  line-height: 20px !important;
  border-radius: 50%;
  color: #fff;
  background-color: #f56c6c;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}
</style>
